import PlayerAvatar from './PlayerAvatar';
import LegalLinks from './LegalLinks';
import React,{useState} from 'react';
import { ChevronRight } from 'lucide-react';
import SettingsDialog from './SettingsDialog';
import ReferenceIcon from './ReferenceIcon';
import { getThemePreference } from '../utils/theme';
export default function SettingsMenu({ onClose, username, displayName, profileImage, onProfile, onAccount, onNotifications, onSound, onRules, onDiagnostics, onLogout, admin, onModeration, onDictionary, onTutorial, onFaq, onNews, onStatistics, onReadability, onTheme, onFriends, onAchievements }) {
  const [adNotice,setAdNotice]=useState('');
  const row = (label, detail, kind, action, status) => <button key={label} type="button" onClick={action} className="reference-menu-row">
    <span className="reference-icon-tile"><ReferenceIcon kind={kind}/></span><span>{label}</span>{status && <small>{status}</small>}<ChevronRight size={20} aria-hidden="true"/>
  </button>;
  const themeLabel = {light:'Açık',dark:'Koyu',system:'Sistem'}[getThemePreference()];
  return <SettingsDialog title="Menü" onClose={onClose} dismiss>
    <button type="button" onClick={onProfile} className="reference-menu-profile mb-6 flex w-full items-center gap-4 rounded-2xl  p-5 text-left shadow-lg">
      <PlayerAvatar username={username} name={displayName} image={profileImage} size={56} className="menu-profile-avatar-r13"/>
      <span className="min-w-0 flex-1"><span className="block truncate text-xl font-black">{displayName}</span><span className="mt-1 block text-sm text-indigo-100">Profilini gör</span></span><ChevronRight size={22} />
    </button>
    <h3 className="reference-group-title">Ayarlar</h3><nav aria-label="Ayarlar" className="reference-card">
      {row('Görünüm','', 'theme', onTheme, themeLabel)}
      {row('Bildirimler','', 'bell', onNotifications)}
      {row('Ses','', 'sound', onSound)}
      {row('Okunabilirlik','', 'readability', onReadability)}
      {window.KelimoNative?.ads&&row('Reklam gizliliği','','shield',()=>window.KelimoNative.ads.privacy().catch(()=>setAdNotice('Reklam gizlilik seçenekleri şu an açılamadı.')))}
      {adNotice&&<p role="status">{adNotice}</p>}
    </nav>
    <h3 className="reference-group-title">Hesap</h3><div className="reference-card">{row('Hesap ve güvenlik','', 'shield', onAccount)}</div>
    <h3 className="reference-group-title">Kelimo</h3><nav aria-label="Kelimo" className="reference-card">
      {row('İstatistikler','', 'stats', onStatistics)}
      {row('Haberler','', 'news', onNews)}
      {row('Nasıl Oynanır','', 'book', onTutorial)}
      {row('Kurallar','', 'rules', onRules)}
      {row('SSS / Destek','', 'faq', onFaq)}
      {row('Bağlantı tanısı','', 'wifi', onDiagnostics)}
    </nav>
    {admin && <><h3 className="reference-group-title">Yönetim</h3><div className="reference-card">{row('Yönetici paneli','', 'shield', onModeration)}{row('Sözlük yönetimi','', 'book', onDictionary)}</div></>}
    <h3 className="reference-group-title">Oturum</h3><div className="reference-card">{row('Hesaptan çık','', 'logout', onLogout)}</div>
    <LegalLinks />
  </SettingsDialog>;
}
